var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128.727,
    height: 143,
    viewBox: "0 0 128.727 143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1277"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon feather-hexagon",
    d: "M128.726 100.106V42.897a14.3 14.3 0 0 0-7.151-12.372L71.515 1.916a14.3 14.3 0 0 0-14.3 0L7.151 30.522A14.3 14.3 0 0 0 0 42.897v57.212a14.3 14.3 0 0 0 7.151 12.372l50.06 28.606a14.3 14.3 0 0 0 14.3 0l50.06-28.606a14.3 14.3 0 0 0 7.155-12.375Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1266",
    transform: "translate(19.15 26.009)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 170",
    cx: 30.915,
    cy: 30.915,
    r: 30.915,
    transform: "translate(30.089)",
    fill: "#1b60a3"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 169",
    cx: 30.915,
    cy: 30.915,
    r: 30.915,
    transform: "translate(0 24.445)",
    fill: "#39beec"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNft);
export default __webpack_public_path__ + "static/media/Nft.e6ccbc0a7017ae0884d8ebfccd845b6c.svg";
export { ForwardRef as ReactComponent };